import React, { SVGProps } from 'react'
const SvgToolbarDownload = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="evenodd"
      d="M10 1.875c.317 0 .578.235.62.54l.005.085v9.324l3.934-3.933a.625.625 0 0 1 .813-.06l.07.06c.222.222.243.57.061.814l-.06.07-5 5a.625.625 0 0 1-.814.06l-.07-.06-5-5a.625.625 0 0 1 .813-.944l.07.06 3.933 3.933V2.5c0-.345.28-.625.625-.625m7.286 12.207a.625.625 0 0 0-.62-.54l-.084.005a.625.625 0 0 0-.54.62v2.451H3.959v-2.451l-.006-.085a.625.625 0 0 0-1.244.085v3.077l.005.084c.042.306.303.54.62.54h13.333l.085-.005a.625.625 0 0 0 .54-.62v-3.076z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgToolbarDownload
